( function () {
	'use strict';
	/* @ngInject */
	/* eslint max-params:0 */
	function EvidenceEditModalCtrl ( $filter, _, $timeout, $scope, TOOLTIP_MESSAGES, EVDICONS, Session, logger, fileService, FILETYPES, evidenceService ) {
		var self = this;
		// scope calls for time synchronization
		var changeTimeReceiver  = 'change:time:' + $scope.evidence.id;
		// this is for counting up time call receiver
		var changeLabelReceiver = 'change:label:timer:bank:' + $scope.evidence.id;
		// call from timer directive, for changing buttons
		// end for scope calls

		function setTimeText ( time ) {
			angular.element( '#modal-timer-' + $scope.index ).text( time );
			self.time = time;
		}

		function activate ( evidence ) {
			self.icons = EVDICONS;
			if ( evidence.type === 6 ) {
				self.count = parseInt( evidence.description, 10 );
			} else if ( evidence.type === 7 ) {
				$timeout( function () {
					setTimeText( evidence.description );
				}, 1 );
				$scope.$root.$broadcast( 'check:timer:', evidence.id );
				// call for checking running time
			}
		}

		function stripMs ( newTime ) {
			return newTime.substring( 0, newTime.length - 1 );
		}

		function editEvidenceName () {
			self.editMode = true;
			self.tempName = angular.copy( $scope.evidence.name );
		}

		function saveEvidenceName () {
			if ( self.tempName ) {
				self.editMode        = false;
				$scope.evidence.name = self.tempName;

				evidenceService.editDeleteEvidence( $scope.evidence, 'edit', $scope.observation );
			}
		}

		function updateEvidenceName ( event, evidenceType ) {
			if ( event.keyCode === 13 && !event.shiftKey && evidenceType === 8 ) {
				saveEvidenceName();
			} else if ( event.keyCode === 13 && evidenceType !== 8 ) {
				saveEvidenceName();
			}
		}

		function cancelUpdateEvidence () {
			self.editMode = false;

			saveEvidenceName();
		}

		function evidenceExists ( evidence, innerLevel ) {
			if ( innerLevel && innerLevel.evidences ) {
				return $filter( 'filter' )( innerLevel.evidences, function ( levelEvidence ) {
					return levelEvidence.id === evidence.id;
				} ).length;
			}

			return false;
		}

		function attachEvidence ( evidence, innerLevel ) {
			if ( !evidenceExists( evidence, innerLevel ) ) {
				if ( !innerLevel.evidences ) {
					innerLevel.evidences = [ ];
				}

				innerLevel.evidences.push( angular.copy( evidence ) );
			}
		}

		function detachEvidence ( evidence, level ) {
			level.evidences.splice( level.evidences.indexOf( evidence ), 1 );
			$scope.$root.$broadcast( 'stop:time:', $scope.evidence.id );
		}

		function counterChange ( evidence ) {
			if ( self.count ) {
				evidence.description = self.count.toString();
				return evidenceService.editDeleteEvidence( evidence, 'edit', $scope.observation );
			}

			self.count = 0;

			evidence.description = self.count.toString();
			evidenceService.editDeleteEvidence( evidence, 'edit', $scope.observation );
		}

		function incrementCount ( evidence ) {
			self.count += 1;
			counterChange( evidence );
		}

		function decrementCount ( evidence ) {
			if ( self.count ) {
				self.count -= 1;
			}

			counterChange( evidence );
		}

		function changeButtonLabel ( evidence, start ) {
			if ( start ) {
				self.timeLabel = 'Stop';
			} else {
				self.timeLabel = 'Start';
			}
		}

		function clearTimerHandler () {
			// call for clearing timer
			$scope.$root.$broadcast( 'clear:time:', $scope.evidence.id );
		}

		function triggerStartStop () {
			if ( self.timeLabel === 'Start' ) {
				// call for start/continue timer
				$scope.$root.$broadcast( 'start:time:', $scope.evidence.id );
			} else {
				$scope.evidence.description = self.time;
				evidenceService.editDeleteEvidence( $scope.evidence, 'edit', $scope.observation );
				$scope.$root.$broadcast( 'stop:time:', $scope.evidence.id );
				// call for stop timer
			}
		}

		function checkEvidenceType ( evidenceType ) {
			if ( ( $scope.$parent.$parent.identifier === 'all' || $scope.$parent.$parent.identifier === 'attached' ) && ( evidenceType !== 4 && evidenceType !== 8 ) ) {
				return 1;
			} else if ( ( $scope.$parent.$parent.identifier === 'all' || $scope.$parent.$parent.identifier === 'attached' ) && ( evidenceType === 4 || evidenceType === 8 ) ) {
				return 2;
			} else if ( $scope.$parent.$parent.identifier === 'available' ) {
				return 3;
			}
		}

		function downloadFile ( ev, evidence ) {
			ev.preventDefault();
			ev.stopPropagation();

			var params = {
				'userId'        : Session.getCredentials().PersonnelId,
				'observationId' : $scope.observation.id,
				'type'          : FILETYPES.observation
			};

			var fileId = evidence.url;

			self.isDownloading = true;

			fileService
			.download( fileId, params, evidence.description )
			.finally( function () {
				self.isDownloading = false;
			} );
		}

		// handlers
		self.editMode             = false;
		self.activate             = activate;
		self.evidenceExists       = evidenceExists;
		self.attachEvidence       = attachEvidence;
		self.detachEvidence       = detachEvidence;
		self.counterChange        = counterChange;
		self.incrementCount       = incrementCount;
		self.decrementCount       = decrementCount;
		self.clearTimer           = clearTimerHandler;
		self.triggerStartStop     = triggerStartStop;
		self.editEvidenceName     = editEvidenceName;
		self.updateEvidenceName   = updateEvidenceName;
		self.cancelUpdateEvidence = cancelUpdateEvidence;
		self.tooltip              = TOOLTIP_MESSAGES;
		self.checkEvidenceType    = checkEvidenceType;
		self.downloadFile         = downloadFile;
		self.isDownloading        = false;

		$scope.$on( changeTimeReceiver, function ( ev, updatedTime ) {
			setTimeText( updatedTime );
		} );

		$scope.$on( changeLabelReceiver, function ( ev, start, time ) {
			if ( time.length === 12 ) {
				time = stripMs( time );
			}

			setTimeText( time || $scope.evidence.description );

			changeButtonLabel( $scope.evidence, start );
		} );
	}

	angular
		.module( 'app.components' )
		.controller( 'EvidenceEditModalCtrl', EvidenceEditModalCtrl );

	EvidenceEditModalCtrl.$inject = [ '$filter', '_', '$timeout', '$scope', 'TOOLTIP_MESSAGES', 'EVDICONS', 'Session', 'logger', 'fileService', 'FILETYPES', 'evidenceService' ];
} )( );
